import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { ListaPreco } from '../interfaces/lista-preco';
import { ListaPrecoTabela } from '../interfaces/lista-preco-tabela';
import { PageResult } from '../interfaces/page-result';
import { Router } from '@angular/router';
import { Item } from '../interfaces/item';
import { environment } from 'environments/environment';
import { JwtAuthService } from './auth/jwt-auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ListaPrecoService {
  readonly url = `/lista/preco`;

  lista_preco$: Observable<ListaPreco>;
  lista_preco: ListaPreco;

  listPrec: ListaPreco;

  item$: Observable<Item>;
  item: Item;

  constructor(
    private http: HttpClient,
    private authService: JwtAuthService) { }

    getListaPreco(id: number): Observable<ListaPreco> {
      return this.http.get<ListaPreco>(`${this.authService.apiUrl + this.url}/${id}`);
    }
    
    /**
     * Retorna Listas de precos 
     * @param page
     * @param size 
     * @returns 
     */
  getListasPreco(page?:number, size?:number): Observable<ListaPreco[]> {
    return this.http.get<ListaPreco[]>(`${this.authService.apiUrl + this.url}/lista/get?page=${page}&size=${size}`)
      .pipe(
        tap(l => console.log(l)),
        catchError((e) => {
          console.log(e);
          return throwError(e);
        })
      );
  }

  saveOrUpdate(lista_preco: ListaPreco): Observable<ListaPreco> {
    console.log('SALVANDO PRECO');
    return this.http.put<ListaPreco>(`${this.authService.apiUrl + this.url}`, lista_preco);
  }

  getListaPrecoPage(page?: number, size?: number): Observable<PageResult<ListaPreco>> {
    return this.http.get<PageResult<ListaPreco>>(`${this.authService.apiUrl + this.url}/page/get/?page=${page}&size=${size}`);
  }

  getListaPrecoPageSearch(page?: number, size?: number, search?: string): Observable<PageResult<ListaPreco>> {
    return this.http.get<PageResult<ListaPreco>>(`${this.authService.apiUrl + this.url}/page/get/?page=${page}&size=${size}&search=${search}`);
  }

  deleteCadastroPreco(id: number ): Observable<any> {
    return this.http.delete<any>(`${this.authService.apiUrl + this.url}/tabela/${id}`);
  }

}
